import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        welcome: 'bienvenue sur votre espace personnel',
        signin: 'login',
        signout: 'logout',
        login: 'email',
        email: 'email',
        password: 'mot de passe',
        activeUser: 'activez votre compte',
        userActivated: 'votre compte a été activé',
        userConfigs: 'paramétrage',
        forgotPassword: 'mot de passe oublié',
        resetPassword: 'changez votre mot de passe',
        currentPassword: 'mot de passe actuel',
        confirmPassword: 'confirmation du mot de passe',
        resetPasswordEmailSent: 'un email vous a été envoyé',
        passwordResetted: 'votre mot de passe a été changé',
        resetLogin: 'changez votre login',
        resetLoginEmailSent: 'un email vous a été envoyé',
        loginResetted: 'votre login a été changé',
        job: 'poste',
        phone: 'téléphone',
        updateUser: 'profile',
        changePassword: 'mot de passe',
        changeEmail: 'email',
        manageAccount: 'gérez votre compte',
        ticketOpenedNotifications: 'recevoir un email lors de la création d\'un ticket',
        daybookNotifications: 'recevoir la main courante',
        simplifiedRequestOpenedNotifications: 'recevoir un email lors de la création d\'une demande simplifiée'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/user/i18n.js